module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-08.ae50473e.svg";